import React from 'react'
import styled from 'styled-components'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
const StyledAboBadge = styled.span<{ tenant: string }>`
  background-color: ${({ tenant }) => 'var(--tenant-' + tenant + ')'};
  color: white;
  font-size: 1.2rem;
  line-height: 1.5rem;
  letter-spacing: 0.25px;
  font-weight: 700;
  margin-right: 0.6rem;
  padding: 2px 6px;
  display: inline-block;
`
let tenantAbrs = {
  tagesanzeiger: 'ta',
  bernerzeitung: 'bz'
}
export const AboBadge = () => {
  console.log(TENANTS[parseHostname().publicationName].abr)
  return (
    <StyledAboBadge tenant={TENANTS[parseHostname().publicationName].abr}>
      Abo
    </StyledAboBadge>
  )
}




export const TENANTS: {
  [key: string]: {
    id: Tenant
    url: string
    abr: string
  }
} = {
  bernerzeitung: {
    id: 'bernerzeitung',
    url: 'bernerzeitung.ch',
    abr: 'bz'
  },
  berneroberlaender: {
    id: 'berneroberlaender',
    url: 'berneroberlaender.ch',
    abr: 'bol'
  },
  langenthalertagblatt: {
    id: 'langenthalertagblatt',
    url: 'langenthalertagblatt.ch',
    abr: 'lt'
  },
  thunertagblatt: {
    id: 'thunertagblatt',
    url: 'thunertagblatt.ch',
    abr: 'tt'
  },
  zsz: {
    id: 'zsz',
    url: 'zsz.ch',
    abr: 'zrz'
  },
  tdg: {
    id: 'tdg',
    url: 'tdg.ch',
    abr: 'tdg'
  },
  zuonline: {
    id: 'zuonline',
    url: 'zuonline.ch',
    abr: 'zul'
  },
  landbote: {
    id: 'landbote',
    url: 'landbote.ch',
    abr: 'l'
  },
  bazonline: {
    id: 'bazonline',
    url: 'bazonline.ch',
    abr: ''
  },
  '24heures': {
    id: '24heures',
    url: '24heures.ch',
    abr: '24h'
  },
  derbund: {
    id: 'derbund',
    url: 'derbund.ch',
    abr: 'bnd'
  },
  tagesanzeiger: {
    id: 'tagesanzeiger',
    url: 'tagesanzeiger.ch',
    abr: 'ta'
  }
}

/*



-tenant-bz: #800000;
    --tenant-bol: #800000;
    --tenant-lt: #800000;
    --tenant-tt: #800000;
    --tenant-zrz: #2c3890;
    --tenant-tdg: #2c3890;
    --tenant-zul: #2c3890;
    --tenant-l: #2c3890;
    --tenant-baz: #d9010e;
    --tenant-24h: #d9010e;
    --tenant-bnd: #0085ab;
    --tenant-ta: #0085ab;


    */
